module.exports = __webpack_public_path__ + "static/media/abe.c738ed81.jpeg";